// 公用接口
import { post } from '~/assets/js/api/methods.js'
import apiList from '~/env.config.js'

const { fxServer, fxClient } = apiList

export default axios => ({
  v3Server: (headers = {}, params = {}) => post(axios, `${fxServer}/wikifxweb-v1/invoke-v3/vps`, params, headers), // 通用请求——服务端
  v3Client: (headers = {}, params = {}) => post(axios, `${fxClient}/wikifxweb-v1/invoke-v3/vps`, params, headers), // 通用请求——客户端
  invokeServer: (headers = {}, params = {}) => post(axios, `${fxServer}/wikifxweb-v1/tradedatacenter/invoke-v1`, params, headers), // 通用请求——服务端
  invokeClient: (headers = {}, params = {}) => post(axios, `${fxClient}/wikifxweb-v1/tradedatacenter/invoke-v1`, params, headers) // 通用请求——客户端
})
